import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/pic/img04.png'
import _imports_1 from '../assets/pic/img05.png'


const _withScopeId = n => (_pushScopeId("data-v-2b1feb0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "headBox" }
const _hoisted_2 = { class: "iconBox" }
const _hoisted_3 = { class: "titlebox" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "imgBox"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "imgBox"
}

import { onMounted, ref } from "vue";
//引入路由
import { useRoute, useRouter } from "vue-router";
//定义路由

export default /*#__PURE__*/_defineComponent({
  __name: 'NetworkAccess',
  setup(__props) {

const route = useRoute();
const router = useRouter();
let isNetworkAccess = ref(false);
//周期函数，获取页面传递的数据
onMounted(async () => {
  isNetworkAccess.value = Number(route.query.type )== 2 ? true : false;
});
const goBack = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_icon, {
          onClick: goBack,
          name: "down",
          class: "iconBack",
          size: "20"
        })
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(isNetworkAccess) ? "入网协议" : "隐私协议"), 1)
    ]),
    (_unref(isNetworkAccess))
      ? (_openBlock(), _createElementBlock("img", _hoisted_4))
      : _createCommentVNode("", true),
    (!_unref(isNetworkAccess))
      ? (_openBlock(), _createElementBlock("img", _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}
}

})